<script lang="js">
import { defineComponent } from "vue";
import Footer from "~/components/Footer.vue";
import Header from "~/components/Header.vue";

export default defineComponent({
  name: "Default",
  components: { Header, Footer },
});
</script>

<template>
  <div>
    <Header />
    <main>
      <div class="header_space"></div>
      <slot />
    </main>
    <Footer />
  </div>
</template>

<style scoped>
main {
  & > .header_space {
    width: 100%;
    height: 80px;
  }
}
</style>